import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { DashboardUnits, LegendData } from '@dataTypes/dashboard.types'
import { formatValueByUnit, formatNumber } from '@utils/index'

type BarChartContentProps = {
  label?: string
  data?: {
    actual: number
    goal: number
    unit: DashboardUnits
  }
  icon: string
  chart: React.ReactElement
  displayActual?: boolean
  legendData?: LegendData[]
  classNameCol?: string
}

function BarChartContent({
  label,
  data,
  icon,
  chart,
  displayActual,
  legendData,
  classNameCol,
}: BarChartContentProps): React.ReactElement {
  return (
    <Row>
      <Col md={12}>
        {label && (label ? <h6>{label}</h6> : <h6>&nbsp;</h6>)}
        {data && (
          <div className="display-6 text-black">
            {`${formatValueByUnit(data.goal, data.unit)}`}
            {displayActual && (
              <span className="fs-6 fw-bold text-blue ms-2">
                <i className={`${icon}`}></i>
                &nbsp;
                {`${formatValueByUnit(data.actual, data.unit)}`}
              </span>
            )}
          </div>
        )}
      </Col>
      <Col md={12}>{chart}</Col>
      {legendData &&
        legendData.map(({ name, value, showCurrency }) => (
          <Col
            className={`${classNameCol ?? 'col-md-3'} mt-2 text-center`}
            key={`${name}`}
          >
            <div className="text-black">{name}</div>
            <div className="text-black fw-bolder">
              {formatNumber(value, showCurrency)}
            </div>
          </Col>
        ))}
    </Row>
  )
}

export default BarChartContent
